import React from "react";

const FraudReferral = () => {
  return <div>FraudReferral</div>;
};

export default FraudReferral;